<div class="contact-container">
  <main>
    <div class="container">
      <div class="contact-header">
        <div class="icon-container">
          <i class="material-icons icon">mail</i>
        </div>
        <h1>Kontakt os</h1>
        <p>
          Hvis du ønsker at få adgang til vores uddannelsesplatform, eller har
          behov for hjælp, så kan du benytte vores kontaktformular herunder, og
          så kontakter vi dig hurtigst muligt!
        </p>
      </div>

      <div class="contact-content">
        <!-- Contact Information -->
        <div class="contact-info">
          <h2>Kom i kontakt</h2>

          <div class="info-item">
            <div class="icon-wrapper">
              <i class="material-icons icon">location_on</i>
            </div>
            <div class="content">
              <h3>Adresse</h3>
              <p>Rastec ApS<br />Danstrupvej 27R<br />3480 Fredensborg</p>
            </div>
          </div>

          <div class="info-item">
            <div class="icon-wrapper">
              <i class="material-icons icon">phone</i>
            </div>
            <div class="content">
              <h3>Telefon</h3>
              <p><a href="tel:+4512345678">+45 49 13 82 08</a></p>
            </div>
          </div>

          <div class="info-item">
            <div class="icon-wrapper">
              <i class="material-icons icon">email</i>
            </div>
            <div class="content">
              <h3>Email</h3>
              <p><a href="mailto:support@duna.dk">support&#64;duna.dk</a></p>
            </div>
          </div>
        </div>

        <!-- Contact Form -->
        <div class="contact-form-wrapper">
          <h2>Send os en besked</h2>
          <p class="form-description">
            Udfyld formularen nedenfor, så vender vi tilbage til dig hurtigst
            muligt.
          </p>

          @if (isSubmitted) {
          <div class="success-message">
            <i class="material-icons success-icon">check_circle</i>
            <p>Tak for din besked! Vi vender tilbage hurtigst muligt.</p>
          </div>
          } @if (!isSubmitted) {
          <form
            (ngSubmit)="onSubmit()"
            class="contact-form"
            #contactForm="ngForm"
          >
            <div
              class="form-group"
              [class.has-error]="nameField.invalid && nameField.touched"
            >
              <label for="navn" class="form-label">Navn*</label>
              <input
                id="navn"
                name="navn"
                type="text"
                [(ngModel)]="name"
                class="form-input"
                placeholder="Dit fulde navn"
                required
                #nameField="ngModel"
              />
              @if (nameField.invalid && nameField.touched) {
              <div class="error-message">Navn er påkrævet</div>
              }
            </div>
            <div
              class="form-group"
              [class.has-error]="emailField.invalid && emailField.touched"
            >
              <label for="email" class="form-label">Email*</label>
              <input
                id="email"
                name="email"
                type="email"
                [(ngModel)]="email"
                class="form-input"
                placeholder="din@email.dk"
                required
                email
                #emailField="ngModel"
              />
              @if (emailField.invalid && emailField.touched) {
              <div class="error-message">
                @if (emailField.errors?.['required']) {
                <span>Email er påkrævet</span>
                } @if (emailField.errors?.['email']) {
                <span>Indtast en gyldig email adresse</span>
                }
              </div>
              }
            </div>
            <div class="form-group">
              <label for="emne" class="form-label">Emne</label>
              <input
                id="emne"
                name="emne"
                type="text"
                [(ngModel)]="subject"
                class="form-input"
                placeholder="Hvad handler din henvendelse om?"
              />
            </div>
            <div
              class="form-group"
              [class.has-error]="messageField.invalid && messageField.touched"
            >
              <label for="besked" class="form-label">Besked*</label>
              <textarea
                id="besked"
                name="besked"
                [(ngModel)]="message"
                class="form-textarea"
                placeholder="Beskriv din henvendelse eller dit spørgsmål her..."
                required
                #messageField="ngModel"
              >
              </textarea>
              @if (messageField.invalid && messageField.touched) {
              <div class="error-message">Besked er påkrævet</div>
              }
            </div>
            <div class="form-actions">
              <button
                type="submit"
                class="submit-button"
                [disabled]="isSubmitting || contactForm.invalid"
              >
                @if (isSubmitting) {
                <i class="material-icons loading-icon">hourglass_empty</i>
                }
                <span>{{ isSubmitting ? "Sender..." : "Send besked" }}</span>
                @if (!isSubmitting) {
                <i class="material-icons icon">send</i>
                }
              </button>
            </div>
          </form>
          }
        </div>
      </div>
    </div>
  </main>
</div>
